export class Resolution {
    constructor(width: number, height: number, isDefault?: boolean) {
        this.width = width;
        this.height = height;
        this.isDefault = isDefault;
    }
    width: number;
    height: number;
    isDefault: boolean = false;
}
